<template>
    <main
        v-if="creatorsData"
        class="m-for-pages"
    >
        <y-container>
            <y-mvp-hero
                v-if="creatorsData"
                class="m-for-pages__hero"
                :hero-data="creatorsData"
            />
        </y-container>
        <div class="m-for-pages__bg1">
            <y-container>
                <y-feature
                    v-if="creatorsData.albums"
                    :albums="creatorsData.albums"
                    class="developers-features"
                />
                <y-banner
                    v-if="creatorsData"
                    class="developers-banner-1"
                    :content="creatorsData"
                />
            </y-container>
        </div>
        <div class="m-for-pages__bg2">
            <y-container>
                <y-tutorials
                    v-if="tutorialsData"
                    class="developers-tutorials"
                    :case-studies-data="tutorialsData"
                    :custom="creatorsData.custom"
                />
                <y-our-client-say
                    v-if="testimonialsContent"
                    class="developers-testimonial"
                    :content="testimonialsContent"
                    :clients-say="testimonialsSlideshow"
                    title-tag="h3"
                />
                <y-cta-complex
                    v-if="testimonialsContent && testimonialsContent.custom"
                    class="developers-banner-2"
                    :title="testimonialsContent.custom.field1"
                    :description="testimonialsContent.custom.field2"
                    :solid-btn-title="testimonialsContent.custom.field3"
                    :solid-btn-link="testimonialsContent.custom.field4"
                    :outlined-btn-title="testimonialsContent.custom.field5"
                    :outlined-btn-link="testimonialsContent.custom.field6"
                    :image-src="testimonialsContent.header_image"
                />
            </y-container>
        </div>
    </main>
</template>

<script >
    import YMvpHero from '@components/ForPagesComponents/Hero/Hero.vue';
    import PageMixin from '@groot-nodes/mixins/Page.js';
    import YBanner from '@components/ForPagesComponents/Banner/Banner.vue';
    import YFeature from '@components/ForPagesComponents/Feature/Feature.vue';
    import YTutorials from '@components/ForPagesComponents/Tutorials/Tutorials.vue';
    import YOurClientSay from '@components/OurClientsSay/Index.vue';
    import YCtaComplex from '@components/ForPagesComponents/CtaComplex/CtaComplex.vue';

    export default {
        name: 'ForCreatorsPage',

        components: {
            YOurClientSay,
            YMvpHero,
            YBanner,
            YFeature,
            YTutorials,
            YCtaComplex,
        },

        mixins: [PageMixin],

        /**
         *
         * @inheritDoc
         */
        data() {
            return {
                creatorsData         : '',
                tutorialsData        : null,
                testimonialsData     : null,
                testimonialsSlideshow: null,
                testimonialsContent  : null,
            };
        },

        /**
         *
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.creatorsData.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.creatorsData.seo_meta_description,
                    },
                ],
            };
        },

        /**
         *
         * @inheritDoc
         */
        methods: {

            /**
             * Find post
             *
             * @param {string} slug
             * @returns {*}
             */
            findPost(slug) {
                return this.home.find((item) => item.slug === slug);
            },

            /**
             * fetch hero data
             *
             * @returns {Promise}
             */
            fetch() {
                this.$wait.start('loading-for-creators');
                const creators = this.$services.Content.postSingle({
                    type     : 'landing-page',
                    slug     : 'for-creators1',
                    including: ['image', 'title', 'synopsis', 'custom', 'title2', 'albums', 'seo_canonical', 'seo_meta_description', 'seo_post_title'],
                    locale   : this.$i18n.locale,

                }).catch((error) => {
                    this.handleError(error);
                });

                const tutorials = this.$services.Content.postList({
                    type     : 'tutorials',
                    slug     : 'for-creators',
                    including: ['image', 'title', 'synopsis', 'custom', 'title2', 'albums'],
                    locale   : this.$i18n.locale,
                    limit    : 3,

                });
                const testimonialSliderShow = this.$services.Content.postList({
                    type     : 'testimonials',
                    tagging  : 'for-creators',
                    including: ['title', 'title2', 'header_image', 'image', 'custom', 'synopsis'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const testimonialContent = this.$services.Content.postSingle({
                    type     : 'landing-page',
                    slug     : 'for-creators2',
                    including: ['image', 'text', 'title', 'custom', 'header_image'],
                    locale   : this.$i18n.locale,

                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([creators, tutorials, testimonialSliderShow, testimonialContent])
                    .then((responses) => {
                        if (this.handleReq(responses, 0)) {
                            this.creatorsData = responses[0].data.results;
                        }

                        if (this.handleReq(responses, 1)) {
                            this.tutorialsData = responses[1].data.results;
                        }

                        if (this.handleReq(responses, 2)) {
                            this.testimonialsSlideshow = responses[2].data.results;
                        }

                        if (this.handleReq(responses, 3)) {
                            this.testimonialsContent = responses[3].data.results;
                        }
                    })
                    .catch((error) => {
                        this.handleError(error);
                    })
                    .finally(() => {
                        this.$wait.end('loading-for-creators');
                    });
            },
        },
    };

</script>

<style lang="scss" src="@/modules/for-pages/scss/for-pages.scss"/>
